import styled from 'styled-components';

export const SearchInputWrapper = styled.div`
  align-items: center;
  background: rgba(235, 235, 235, 0.95);
  display: flex;
  height: 52px;
  padding: 0.5em;
  position: absolute;
  right: 0;
  top: 40px;
  width: 100vw;
  z-index: 3000;
`;

export const StyledSearchInput = styled.input`
  appearance: none;
  border-radius: 2px;
  border: 1px solid #c8c8c8;
  font-family: inherit;
  font-size: 1rem;
  min-height: 100%;
  padding: 0 0.625em;
  width: 100%;
`;
